export const idAdministrador = '1c646f52-03b6-4237-a6ff-00db11c4fb14';
export const idVisualizador = '311ffcb5-39d9-4912-8010-34320ffd33b5';
export const idTransportista = '7b2150a5-fba0-407e-bade-9ccec0a06c35';
export const idLiquidador = 'ce7b6cb4-5c77-4ab0-972d-3d10c59744da';


